<template>
<Loader :isLoading="isLoading"/>
  <div class="py-4 container-fluid" v-show="!isLoading">
    <div class="row">
      <div class="col-12 mt-2 col-sm-6 col-lg-4" v-for="(trip, index) in tripOpenTrip" v-show="tripOpenTrip.length != 0" :key="index">
        
        <div class="card mb-3">
          <div class="card-header text-end">
            <div class="row">
              <div class="col-12 col-sm-6 text-start">
                <span class="badge bg-success" >Disponibles: {{trip.enableSeats}}</span>
              </div>
              <div class="col-12 col-sm-6 text-end">
                <span class=" clickeable" title="Ver asientos" @click="viewPassengersDetail(trip.id)"><i class="fas fa-users text-secondary"></i></span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 mb-2">
                <span class="font-weight-bold me-2">Fecha inicio:</span>
                 <span >{{trip.schedule.startDate}}</span>
              </div>
              <div class="col-12 mb-4">
                 <span class="font-weight-bold me-2">Fecha fin:</span>
                 <span >{{trip.schedule.endDate}}</span>
              </div>

              <div class="col-12 mb-2 text-center">
                  <span v-if="trip.status == 1" class="badge bg-success">En espera</span>
                  <span v-if="trip.status == 2" class="badge bg-info">En curso</span>
                  <span v-if="trip.status == 3" class="badge bg-secondary">Finalizado</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-2" v-show="tripOpenTrip.length == 0">
          <div class="alert bg-warning text-dark text-center" role="alert">
             No hay viajes finalizados o en curso
          </div>
      </div>
    </div>
  </div>

     <MDBModal
    id="newRouteEndPositionModal"
    tabindex="-1"
    size="lg"
    labelledby="newRouteEndPositionModalLabel"
    v-model="passengerModal"
  >
    <MDBModalHeader>
      <MDBModalTitle id="exampleModalLabel">Pasajeros</MDBModalTitle>
    </MDBModalHeader>
    <MDBModalBody>
          <LoaderModal :isLoading="isLoadingModal"/>
          <div class="row">
            <div class="col-12 table-responsive">
              <table id="passenger-list" class="table table-flush">
                <thead class="thead-light">
                  <tr>
                    <th style="font-size: 0.65em; font-weight: bold; text-align: start">#</th>
                    <th style="font-size: 0.65em; font-weight: bold">Usuario</th>
                    <th style="font-size: 0.65em; font-weight: bold">Correo</th>
                    <th style="font-size: 0.65em; font-weight: bold">No. Asientos</th>
                    <!--<th style="font-size: 0.65em; font-weight: bold">Acciones</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(passenger, index) in passengers" :key="index">
                    <td class="text-center">
                      {{index + 1}}
                    </td> 
                    <td class="text-sm">{{passenger.client?.username}}</td>
                    <td class="text-sm text-center">{{passenger.client?.email}}</td>
                    <td class="text-sm text-center">{{passenger.seating}}</td>
                    <!--<td class="text-sm text-center">
                          <a
                          title="Más detalles"
                          class="mx-3 clickeable"
                          >
                            <i class="fas fa-eye text-secondary"></i>
                          </a> 
                    </td>-->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

    </MDBModalBody>
    <MDBModalFooter >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-center">
            <button  class="btn bg-gradient-dark" title="Cerrar" @click="closeModal()">Cerrar</button>
          </div>
        </div>
      </div>
    </MDBModalFooter>
  </MDBModal>
</template>

<script>
import Loader from '../../../../components/Loader.vue'
import listTripsOpenTrips from '../../../openTrip/use-cases/list.trips.opentrips'
import getPassengers from '../../../openTrip/use-cases/get.passengers'
import moment from 'moment'
import LoaderModal from '../../../../components/LoaderModal.vue'
 import {  MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalFooter
  } from 'mdb-vue-ui-kit';
import DataTable from 'datatables.net-dt';
import $ from 'jquery';

export default {
  name: "ListOpenTrip",
  components:{
    Loader,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalFooter,
    LoaderModal
  },
  data(){
    return {
      trips: [],
      datatable: null,
      isLoading: false,
      idOpenTrip: 0,
      tripOpenTrip: [],
      passengerModal: false,
      isLoadingModal: false,
      passengers: []
    }
  },
  async mounted() {
    this.idOpenTrip = this.$route.params.id;
    await this.listTripsOpenTrips(this.idOpenTrip)
  },
  methods:{

      async listTripsOpenTrips(id){
         this.isLoading = true;
          const response = {...await listTripsOpenTrips(id)};
          const {error, data} = response;
          this.isLoading = false;
          if(!error){
              const {result} = data
              this.tripOpenTrip = result.map((trip) => {
                  const {startDate, endDate} = trip.schedule;
                  return {...trip, schedule: {...trip.schedule, startDate: moment(startDate).format('DD-MM-YYYY HH:mm'),endDate:  moment(endDate).format('DD-MM-YYYY HH:mm')}}
              })

          }else{
              this.$swal({
                icon: "error", 
                title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
                type: "basic",
              });
          }
    },
    closeModal(){
      this.passengerModal = false;
    },
    async viewPassengersDetail(id){
        this.passengerModal = true;
        this.isLoadingModal = true
        await this.initializaDatatable({id})
        this.isLoadingModal = false;
    },
    async initializaDatatable(payload){
      try{
         const {data:{result} } = await getPassengers(payload);
         this.passengers = result
         console.log(this.passengers);
         if(this.datatable){
          this.datatable.destroy()
         }
        this.$nextTick(()=>{
         this.datatable =  new DataTable('#passenger-list', {
          searching: true,
          ordering: true,
          pageLength:5,
          lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, "Mostrar todos"]],
          language:{
            infoEmpty: "",
            url: 'https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json',
            paginate: {
                    next: ">"
                },
            search: "",
            searchPlaceholder: "Buscar...",
            
          },
          pagingType: "simple_numbers",
          drawCallback: ()=>{
                $('#passenger-list_previous').addClass('d-none');
          },
          columnDefs: [
                {
                    targets: [0, 1, 2], // Índices de las columnas que deben ser visibles
                    visible: true
                }
          ]
          });
        })
      }catch(err){
        this.$swal({icon: "error", title: err, type: "basic" });
      }
    },
  }
};
</script>

<style scoped>
  .clickeable{
    cursor: pointer;
  }
</style>